<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { AdvancedCardV2, LabelV2 } from '@Shelly/shelly-design-system';

	export let title: string;
	export let subtitle = '';
	export let icon: string;
	export let selected = false;
	export let count: number | undefined;
	export let ariaLabel: string;

	const dispatch = createEventDispatcher<{ select: void }>();
</script>

<AdvancedCardV2
	class="catalog-navigation-card"
	{title}
	{selected}
	isCondensed
	isFocusable
	avatar={{ icon }}
	subtitle={subtitle ? { value: subtitle, bold: false } : null}
	aria-label={ariaLabel}
	hideSlotRightBadge={count === undefined}
	on:click={() => dispatch('select')}
>
	{#if count !== undefined}
		<LabelV2 slot="rightBadge" size="s" value={String(count)} type="secondary" />
	{/if}
</AdvancedCardV2>

<style>
	:global(.catalog-navigation-card) {
		width: 100%;
	}
</style>
